import { useContext } from 'react';

import FilterContext from './FilterContext';

const useFilterProvider = () => useContext(FilterContext);

export default useFilterProvider;
